<template>
  <ClientOnly>
    <span class="relative inline-block rotate-180 align-middle">
      <input
        :id="inputId"
        type="checkbox"
        class="opacity-0 absolute inset-0 w-full h-full z-10 cursor-pointer"
        :checked="isDark"
        :title="title"
        :aria-label="title"
        @change="toggle"
      />
      <label
        :for="inputId"
        class="flex items-center justify-between px-1 w-12 h-6 rounded-full shadow-sm cursor-pointer"
        :class="labelClass"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
          class="w-[14px] h-[14px] text-amber-400 shrink-0"
        >
          <path d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
          class="w-[14px] h-[14px] text-amber-400 shrink-0"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 3v2.25M12 18.75V21M5.25 12H3M21 12h-2.25M5.636 5.636l1.591 1.591M16.773 16.773l1.591 1.591M5.636 18.364l1.591-1.591M16.773 7.227l1.591-1.591" />
        </svg>
        <span
          class="absolute top-[2px] left-[2px] w-5 h-5 rounded-full transition-transform"
          :class="[ballColorClass, ballPositionClass]"
        />
      </label>
    </span>
  </ClientOnly>
</template>

<script setup>
const props = defineProps({
  variant: {
    type: String,
    default: "dark",
    validator: (v) => ["dark", "light"].includes(v),
  },
});

const { t } = useI18n();
const colorMode = useColorMode();

const inputId = `dark-toggle-pill-${Math.random().toString(36).slice(2, 8)}`;

const isDark = computed(() => colorMode.value === "dark");

const title = computed(() =>
  isDark.value
    ? t("controls.theme.switchToLight")
    : t("controls.theme.switchToDark")
);

// On dark (tagline, always slate-900 bg) pill stays a muted navy so it stands out.
// On light (nonavbar, adaptive bg) pill flips between dark/white to match the site theme.
const labelClass = computed(() =>
  props.variant === "dark"
    ? "bg-slate-700"
    : "bg-slate-900 dark:bg-white dark:shadow-gray-800"
);

const ballColorClass = computed(() =>
  props.variant === "dark"
    ? "bg-white"
    : "bg-white dark:bg-slate-900"
);

const ballPositionClass = computed(() =>
  isDark.value ? "translate-x-[24px]" : "translate-x-0"
);

const toggle = () => {
  colorMode.preference = isDark.value ? "light" : "dark";
};
</script>
